import { render, staticRenderFns } from "./DateRangeButton.vue?vue&type=template&id=1736dc69&"
import script from "./DateRangeButton.vue?vue&type=script&lang=js&"
export * from "./DateRangeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports